import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import Qrcode from "./Qrcode";

const QrModalCard = ({ isQrModalOpen, setIsQrModalOpen, onTrack }) => {
  const closeModal = () => {
    onTrack?.("qr_modal_close", {
      source: "public_card",
    });
    setIsQrModalOpen(false);
  };

  return (
    <Transition.Root show={isQrModalOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        onClose={() => {}}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-[#1b8395] bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed z-10 inset-0 overflow-y-auto">
          <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative bg-white rounded-2xl px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-sm sm:w-full sm:p-6">
                <h2 className="text-xl font-bold text-[#1b8395] text-center mb-4">QR Code</h2>
                <p className="text-gray-600 text-center mb-4 text-sm">
                  Scansiona questo codice per condividere il biglietto da visita digitale
                </p>
                {isQrModalOpen && <Qrcode />}
                <div className="mt-5">
                  <button
                    type="button"
                    className="inline-flex justify-center w-full rounded-xl border border-transparent px-4 py-3 bg-[#20acad] text-white font-semibold hover:bg-[#1b8395] focus:outline-none transition-colors"
                    onClick={closeModal}
                  >
                    Torna alla card
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default QrModalCard;
